import { required } from 'vuelidate/lib/validators'

export const riskModel = {
  form: {
    name: {
      required
    },
    description: { }
  }
}
